import tierSPlus from '@wwe-portal/ui/assets/images/roster/tier/splus.webp';
import tierS from '@wwe-portal/ui/assets/images/roster/tier/s.webp';
import tierA from '@wwe-portal/ui/assets/images/roster/tier/a.webp';
import tierB from '@wwe-portal/ui/assets/images/roster/tier/b.png';
import tierC from '@wwe-portal/ui/assets/images/roster/tier/c.png';
import { mapArrayToRecord } from '@wwe-portal/utils/array';

export const tiers = [
  { id: 'SPlus', title: 'S+', iconUrl: tierSPlus },
  { id: 'S', title: 'S', iconUrl: tierS },
  { id: 'A', title: 'A', iconUrl: tierA },
  { id: 'B', title: 'B', iconUrl: tierB },
  { id: 'C', title: 'C', iconUrl: tierC },
];

export const tiersMap = mapArrayToRecord(tiers, (item) => item.id);
